import { createContext, useContext } from "react";

import { TablesManagementState } from "features/TablesManagement/types";

export const TablesManagementContext = createContext<TablesManagementState | null>(null);

export const useTablesManagementContext = (): TablesManagementState => {
    const state = useContext(TablesManagementContext);

    if (!state) {
        throw new Error("useTablesManagementContext должен использоваться внутри TablesManagement");
    }

    return state;
};
